import { useState } from "react";
import { AstrologyCard } from "../AstrologyCard";
import { ChineseAstrologyContainer } from "./style";
import { LinkAbsolute } from "@/shared/LinkAbsolute";

export const ChineseAstrology = ({ zodiac, isChineseLanding = false }) => {
  const [birthdate, setBirthdate] = useState("");
  const [result, setResult] = useState([]);

  const checkDateInRange = (dateString, dateRanges) => {
    const [year, month, day] = dateString.split('-');
    const inputDate = new Date(year, month - 1, day);
    const foundRange = dateRanges.find(range => {
      const [start, end] = range.split(' - ').map(date => {
        const [rangeDay, rangeMonth, rangeYear] = date.split('/');
        const formattedDate = new Date(rangeYear, rangeMonth - 1, rangeDay);
        return formattedDate;
      });
      return inputDate >= start && inputDate <= end;
    }); 
    return foundRange || null;
  };
  const TagTitle = isChineseLanding ? "h1" : "h2";

  
  const getSign = () => {
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
  
    if (!datePattern.test(birthdate)) {
      return;
    }
  
    const results = zodiac.map((element) => {
      if (checkDateInRange(birthdate, element?.dates)) {
        const [year] = birthdate.split('-');
        return result ? { ...element, years: [year] } : null;
      }
    });
  
    setResult(results.filter(Boolean));
  };

  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
  
    // Asegurarse de que el mes y el día tengan dos dígitos
    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;
  
    // Formatear la fecha como 'YYYY-MM-DD'
    return `${day}/${month}/${year}`;
  }

  return (
    <ChineseAstrologyContainer>
      <div className={
            isChineseLanding
              ? "chinese-astrology-header"
              : "chinese-astrology-header line-top"
          }>
        <TagTitle
          className={
            isChineseLanding
              ? "chinese-astrology-landing-header-title"
              : "chinese-astrology-header-title"
          }
        >
          Horóscopo Chino
          <LinkAbsolute href="/horoscopo-chino" target="_self" aria-label="horoscopo chino" />
        </TagTitle>
        {isChineseLanding ? (
          <p className="chinese-astrology-landing-description-text">
            La astrología está considerada en China una de las cinco artes más antiguas de adivinación. El horóscopo chino se basa principalmente en la fecha de nacimiento; por eso lo primero que debés hacer para conocer más sobre tu signo es chequear cuál es tu signo en el horóscopo chino.<br/><br/>A continuación, conocé cuál es tu animal en el horóscopo chino según tu fecha de nacimiento.
            </p>
        ) : null}
      </div>

      <div className="chinese-astrology-description">
        {!isChineseLanding ? (
          <p className="chinese-astrology-description-text">
            En la astrología china, cada personalidad individual se asocia con
            un animal que la represente, según el año de nacimiento.
          </p>
        ) : null}

        <form
          className={
            isChineseLanding
              ? "chinese-astrology-landing-input"
              : "chinese-astrology-input"
          }
          onSubmit={(e) => e.preventDefault()}
        >
          <label className="chinese-astrology-input-text">
            {/* Escribe tu fecha de nacimiento para conocer tu signo */}
            Escribí tu fecha de nacimiento para conocer tu animal en el horóscopo chino
          </label>

          <div className="chinese-astrology-inputs-container">
            <input 
              type="date"
              value={birthdate || ''}
              placeholder="Ej: 01/01/1987"
              onChange={(e) => {
                let value = e.target.value;
                setBirthdate(value);
              }}
            />
            <input
              className="chinese-astrology-input-button"
              type="submit"
              value="Enviar"
              onClick={getSign}
            />
          </div>
        </form>
      </div>

      <div className="western-astrology-content">
        {result.length === 0 ? (
          <AstrologyCard zodiac={zodiac} isChineseLanding/>
        ) : (
          <AstrologyCard zodiac={result} isChineseLanding/>
        )}
      </div>
    </ChineseAstrologyContainer>
  );
};
